import { IS_QB_CACHE_RUNNING, QB_CACHE_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = {
  isQBCacheRunning: false,
  qbCacheSucceeded: null
};

export default function qbCache(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case IS_QB_CACHE_RUNNING:
      return {
        ...state,
        isQBCacheRunning: action.data
      };
    case QB_CACHE_FETCHED:
      return {
        ...state,
        qbCacheSucceeded: action.data
      };
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
